import HTTPStatus from 'http-status';
import { AVIS_INICIALITZAR, AVIS_INTRODUCCIO_INICIALITZAR_METEORS,
    AVIS_VISUALITZACIO_OBTENIR, AVIS_VISUALITZACIO_SELECCIONAR_AVIS,
    AVIS_VISUALITZACIO_ACTUALITZAR_IDS_AVISOS_DEL_MAPA,
    AVIS_INTRODUCCIO_MODIFICAR_DATA, AVIS_INTRODUCCIO_MODIFICAR_VIGILANT, AVIS_INTRODUCCIO_MODIFICAR_COORDENADES,
    AVIS_INTRODUCCIO_MODIFICAR_ALTITUD, AVIS_INTRODUCCIO_MODIFICAR_METEOR, AVIS_INTRODUCCIO_MODIFICAR_VALOR,
    AVIS_INTRODUCCIO_OBTENIR_METEORS, AVIS_INTRODUCCIO_INICIALITZAR_VALORS,
    AVIS_INTRODUCCIO_COMPROVAR, AVIS_INTRODUCCIO_INSERIR_EN_CURS,
    AVIS_INTRODUCCIO_INSERIR_FINALITZADA, AVIS_VISUALITZACIO_OBTENIR_EN_CURS,
    AVIS_VISUALITZACIO_OBTENIR_METEORS_EN_CURS, AVIS_VISUALITZACIO_OBTENIR_METEORS_FINALITZAT,
    AVIS_VISUALITZACIO_OBTENIR_FINALITZADA, AVIS_VISUALITZACIO_INSERIR_COMENTARI_FINALITZADA,
    AVIS_VISUALITZACIO_INSERIR_COMENTARI_EN_CURS, AVIS_VISUALITZACIO_OBTENIR_COMENTARIS,
    AVIS_VISUALITZACIO_OBTENIR_COMENTARIS_EN_CURS, AVIS_VISUALITZACIO_OBTENIR_COMENTARIS_FINALITZADA,
    AVIS_VISUALITZACIO_ELIMINAR_COMENTARI, AVIS_VISUALITZACIO_ELIMINAR_COMENTARI_EN_CURS,
    AVIS_VISUALITZACIO_ELIMINAR_COMENTARI_FINALITZADA, AVIS_VISUALITZACIO_MODIFICAR_TEXT_NOU_COMENTARI,
    AVIS_VISUALITZACIO_ELIMINAR_AVIS_EN_CURS, AVIS_VISUALITZACIO_ELIMINAR_AVIS_FINALITZADA,
    AVIS_VISUALITZACIO_ELIMINAR, AVIS_OMPLIR_FORMULARI_AMB_UN_AVIS,
    AVIS_INTRODUCCIO_MODIFICAR_URL_FOTO_A_ELIMINAR, AVIS_VISUALITZACIO_OBTENIR_ULTIMA_DATA_RADAR } from './actionTypes';

import { crearNotificacioSuccess, crearNotificacioWarning, crearNotificacioError } from '../commons/notificacio';
import { fetchAvisosFormulariMeteors, fetchAvisFormulariEnviar, fetchAvisComentaris,
    fetchObtenirAvisos, fetchAvisEliminarComentari, fetchInserirComentari,
    fetchEditarAvis, fetchAvisEliminar, fetchObtenirUltimaDataRadar,
    fetchObtenirAvisosUltimes24h } from '../commons/consultesServidor';
import { rutaAvisos } from '../routes/routeConstants';
import { selectorLogin } from '../selectors/selector_login';
import { convertirMomentATextEnLocal, convertirTextAMomentLocal } from '../commons/gestioDates';

import { errorConsultaServidor } from './error';
import { obtenirDataHoraActualUTC } from './data';
import { obtenirMunicipis } from './municipi';

export const onEnterAvis = () => {
    return dispatch => {
        dispatch(inicialitzaAvis());
        dispatch(obtenirDataHoraActualUTC());
        dispatch(avisObtenirMeteors());
    };
};

export const onEnterAvisCrear = () => {

    return (dispatch, getState) => {
        const estat = getState();
        const dataAvisText = estat.avis.formulari.dades.data;
        const idVigilant = estat.avis.formulari.dades.idVigilant;
        const idUsuari = selectorLogin(estat).idUsuari;

        dispatch(obtenirMunicipis());
        dispatch(obtenirDataHoraActualUTC())
            .then(() => {
                const dataActualText = getState().dataActual;

                if (!dataAvisText && dataActualText) {
                    const dataActual = convertirTextAMomentLocal(dataActualText);
                    dispatch(avisFormulariObtenirDataAvis(dataActual));
                }
            });
        // Si estem creant un avís (no editant) s'ha d'indicar que l'usuari connectat és qui el realitza
        if (!idVigilant && idUsuari) {
            dispatch(avisIntroduccioModificarVigilant(idUsuari));
        }
    };
};

export const eliminarAvis = (idAvis) => {
    return (dispatch) => {

        dispatch(peticioEliminarAvisEnCurs(idAvis));

        return fetchAvisEliminar(idAvis)
            .then(() => {
                dispatch(avisVisualitzacioSeleccionarAvis(null)); //tancar el detall
                dispatch(avisVisualitzacioEliminar(idAvis)); // treure del llistat actual d'avisos
                dispatch(peticioEliminarAvisFinalitzada());

                const notificacioEliminarAvisExit = 'Avís eliminat correctament';
                crearNotificacioSuccess(notificacioEliminarAvisExit);
            },(errorServidor) => {
                dispatch(peticioEliminarAvisFinalitzada());
                const missatgePerUsuari = 'Error eliminant avís';
                dispatch(errorConsultaServidor(errorServidor, missatgePerUsuari));
            });
    };
};

/**
 * Retorna l'acció per indicar que la petició d'eliminar un avís amb idAvis es troba en curs
 * @param idAvis {Integer}
 * @returns {type: AVIS_VISUALITZACIO_ELIMINAR_AVIS_EN_CURS, id: {Integer}}
 */
const peticioEliminarAvisEnCurs = (idAvis) => {
    return {
        type: AVIS_VISUALITZACIO_ELIMINAR_AVIS_EN_CURS,
        id: idAvis
    };
};

/**
 * Retorna l'acció per indicar que la petició d'eliminar un avís ha finalitzat
 * @param idAvis {Integer}
 * @returns {type: AVIS_VISUALITZACIO_ELIMINAR_AVIS_FINALITZADA}
 */
const peticioEliminarAvisFinalitzada = () => {
    return {
        type: AVIS_VISUALITZACIO_ELIMINAR_AVIS_FINALITZADA,
    };
};

/**
 * Retorna l'acció que elimina l'avís amb idAvis de l'estat
 * @param idAvis {Integer}
 * @returns {type: AVIS_VISUALITZACIO_ELIMINAR, id: {Integer}}
 */
const avisVisualitzacioEliminar= (idAvis) => {
    return {
        type: AVIS_VISUALITZACIO_ELIMINAR,
        id: idAvis
    };
};

/**
 * Es modifica el text del comentari que es vol inserir
 *
 * @param text {String}
 * @returns {{type}|*}
 */
export const avisVisualitzacioModificarTextNouComentari = (text) => {
    return {
        type: AVIS_VISUALITZACIO_MODIFICAR_TEXT_NOU_COMENTARI,
        text
    };
};

/**
 * Petició d'inserció d'un comentari d'un usuari
 *
 * @param idUsuari {Number}, text {String}
 * @returns {*}
 */
export const inserirComentariAvis = (idUsuari, text) => {
    return (dispatch) => {
        dispatch(avisVisualitzacioInserirComentariEnCurs());

        return fetchInserirComentari({idUsuari, text})
            .then((resposta) => {
                const estatResposta = resposta.status;
                const comentaris = resposta.body;

                dispatch(avisVisualitzacioInserirComentariFinalitzada());
                dispatch(avisVisualitzacioModificarTextNouComentari(''));

                if (estatResposta === HTTPStatus.PARTIAL_CONTENT) {
                    const notificacioCrearComentariAdvertencia = {
                        titol: 'Comentari inserit correctament',
                        descripcio: 'El llistat que apareix no està actualitzat.'
                    };
                    crearNotificacioWarning(notificacioCrearComentariAdvertencia.titol,
                        notificacioCrearComentariAdvertencia.descripcio);
                    return;
                }

                dispatch(avisVisualitzacioObtenirComentaris(comentaris));
            },(errorServidor) => {
                dispatch(avisVisualitzacioInserirComentariFinalitzada());
                dispatch(errorConsultaServidor(errorServidor));
            });
    };
};

/**
 * S'informa que la petició al servidor per inserir un comentari, s'ha iniciat
 * i està en curs.
 *
 * @returns {{type}|*}
 */
export const avisVisualitzacioInserirComentariEnCurs = () => {
    return {
        type: AVIS_VISUALITZACIO_INSERIR_COMENTARI_EN_CURS
    };
};

/**
 * S'informa que la petició al servidor per inserir un comentari, ha finalitzat
 * ja sigui correctament o amb error.
 *
 * @returns {{type}|*}
 */
export const avisVisualitzacioInserirComentariFinalitzada = () => {
    return {
        type: AVIS_VISUALITZACIO_INSERIR_COMENTARI_FINALITZADA
    };
};

/**
 * Consulta per recuperar els avisos d'un periode al servidor o de les
 * últimes 24h
 *
 * @param dataInici {Moment}, dataFi {Moment}
 * @returns {*}
 */
export const obtenirAvisos = (dataInici, dataFi) => {
    return (dispatch) => {
        dispatch(peticioObtenirAvisosEnCurs());

        let promise;

        if (!dataInici || !dataFi) {
            promise = fetchObtenirAvisosUltimes24h();
        } else {
            promise = fetchObtenirAvisos(dataInici, dataFi);
        }

        return promise
            .then((respostaServidor) => {
                dispatch(avisVisualitzacioObtenir(respostaServidor.avisos));
                dispatch(peticioObtenirAvisosFinalitzada());
                return respostaServidor.dataPeticio;
            },(errorServidor) => {
                dispatch(peticioObtenirAvisosFinalitzada());
                const notificacioObtenirAvisosError = 'Error obtenint els avisos';
                dispatch(errorConsultaServidor(errorServidor, notificacioObtenirAvisosError));
            });
    };
};

/**
 * S'informa que la petició al servidor per obtenir els avisos, s'ha iniciat
 * i està en curs.
 *
 * @returns {{type}|*}
 */
const peticioObtenirAvisosEnCurs = () => {
    return {
        type: AVIS_VISUALITZACIO_OBTENIR_EN_CURS
    };
};

/**
 * S'informa que la petició al servidor per obtenir els avisos, ha finalitzat
 * ja sigui correctament o amb error.
 *
 * @returns {{type}|*}
 */
const peticioObtenirAvisosFinalitzada = () => {
    return {
        type: AVIS_VISUALITZACIO_OBTENIR_FINALITZADA
    };
};

/**
 * S'informa de la modificació de la llista d'avisos.
 *
 * @param periode {Array} Avisos
 * @returns {{type, avisos}|*}
 */
const avisVisualitzacioObtenir = (avisos) => {
    return {
        type: AVIS_VISUALITZACIO_OBTENIR,
        avisos
    };
};

/**
 * Inicialitza tot l'estat referent al domini d'Avisos.
 *
 * @returns {{type}|*}
 */
export const inicialitzaAvis = () => {
    return {
        type: AVIS_INICIALITZAR
    };
};

/**
 * Selecciona un avis per veure el detall
 *
 * @param {Number || null} idAvisSeleccionat
 * @returns {{type, number}|*}
 */
export const avisVisualitzacioSeleccionarAvis = (idAvisSeleccionat) => {
    return {
        type: AVIS_VISUALITZACIO_SELECCIONAR_AVIS,
        idAvisSeleccionat
    };
};

/**
 * S'informa de la modificació dels meteors del formulari d'inserir avisos.
 *
 * @param periode {Object} Estructura de meteors provinent del servidor
 * @returns {{type, meteors}|*}
 */
const avisMeteors = (meteors) => {
    return {
        type: AVIS_INTRODUCCIO_OBTENIR_METEORS,
        meteors
    };
};

/**
 * S'informa de la modificació dels avisos que s'han de visualitzar al llistat
 *
 * @param idsFiltratsPelMapa {Array} Number
 * @returns {{type, idsFiltratsPelMapa}|*}
 */
export const avisVisualitzacioActualitzarIdsAvisosPelMapa = (idsFiltratsPelMapa) => {
    return {
        type: AVIS_VISUALITZACIO_ACTUALITZAR_IDS_AVISOS_DEL_MAPA,
        idsFiltratsPelMapa
    };
};

/**
 * S'inicialitza l'estat referent al llistat de meteors del formulari d'inserir avís.
 *
 * @returns {{type}|*}
 */
const avisIntroduccioMeteorsInicialitzar = () => {
    return {
        type: AVIS_INTRODUCCIO_INICIALITZAR_METEORS
    };
};

/**
 * Llença l'acció que indica que la petició per obtenir els meteors esta en curs.
 */
export const peticioObtenirMeteorsEnCurs = () => {
    return {
        type: AVIS_VISUALITZACIO_OBTENIR_METEORS_EN_CURS
    };
};

/**
 * Es llença un cop s'ha acabat la petició al servidor.
 */
export const peticioObtenirMeteorsFinalitzat = () => {
    return {
        type: AVIS_VISUALITZACIO_OBTENIR_METEORS_FINALITZAT
    };
};

/**
 * Consulta els meteors del formulari d'inserir avisos i llança les accions
 * corresponents depenent del resultat d'aquesta consulta
 *
 * @returns {*}
 */
export const avisObtenirMeteors = () => {

    return (dispatch) => {
        dispatch(peticioObtenirMeteorsEnCurs());

        return fetchAvisosFormulariMeteors()
            .then((meteors) => {

                dispatch(peticioObtenirMeteorsFinalitzat());

                if (!meteors || Object.keys(meteors).length === 0) {
                    const notificacioNoMeteorsError = 'La llista de meteors està buida. No es poden mostrar els avisos.';
                    crearNotificacioError(notificacioNoMeteorsError);
                }

                dispatch(avisMeteors(meteors));
            },(errorServidor) => {
                dispatch(avisIntroduccioMeteorsInicialitzar());
                dispatch(peticioObtenirMeteorsFinalitzat());
                dispatch(errorConsultaServidor(errorServidor));
            });
    };
};

/**
 * S'informa de la modificació de la data d'introducció d'un avís.
 *
 * @param periode {Moment} Data de l'avís
 * @returns {{type, dataAvis}|*}
 */
export const avisFormulariObtenirDataAvis = (dataAvis) => {
    const dataAvisText = convertirMomentATextEnLocal(dataAvis);
    return {
        type: AVIS_INTRODUCCIO_MODIFICAR_DATA,
        dataAvis: dataAvisText
    };
};

/**
 * Modificació del vigilant
 * @param idVigilant
 */
export const avisIntroduccioModificarVigilant = (idVigilant) => {
    return {
        type: AVIS_INTRODUCCIO_MODIFICAR_VIGILANT,
        idVigilant
    };
};

/**
 * Modificació de les coordenades seleccionades
 * @param {*} coordenades
 */
export const avisIntroduccioModificarCoordenades = (coordenades) => {
    return {
        type: AVIS_INTRODUCCIO_MODIFICAR_COORDENADES,
        coordenades
    };
};

/*
 * Modificació de la altitud seleccionada
 **/
export const avisIntroduccioModificarAltitud = (altitud) => {
    return {
        type: AVIS_INTRODUCCIO_MODIFICAR_ALTITUD,
        altitud
    };
};

/*
 * Modificació del meteor seleccionat
 ***/
export const avisIntroduccioModificarMeteor = (idMeteorSeleccionat) => {
    return {
        type: AVIS_INTRODUCCIO_MODIFICAR_METEOR,
        idMeteorSeleccionat
    };
};

/**
 * Retorna l'acció per modificar el valor d'un camp dintre del formulari de introducció avís.
 * @param idCamp {String}
 * @param valor {String}
 * @returns {{type: AVIS_INTRODUCCIO_MODIFICAR_VALOR, idCamp: *, valor: *}}
 */
export const avisIntroduccioModificarValor = (idCamp, valor) => {
    return {
        type: AVIS_INTRODUCCIO_MODIFICAR_VALOR,
        idCamp: idCamp,
        valor: valor
    };
};

/**
 * Retorna l'acció per inicialitzar el camp valors del formulari de introducció avís.
 * @returns {{type: AVIS_INTRODUCCIO_INICIALITZAR_VALORS}}
 */
export const avisIntroduccioInicialitzarValors = () => {
    return {
        type: AVIS_INTRODUCCIO_INICIALITZAR_VALORS,
    };
};

/**
 * Retorna l'acció que comprovar si s'han informat totes les dades obligatòries de l'avis
 * @returns {{type: AVIS_INTRODUCCIO_COMPROVAR, dades: {Object}}}
 */
const checkAvisFormulariEnviar = (dades, meteors) => {
    return {
        type: AVIS_INTRODUCCIO_COMPROVAR,
        dades,
        meteors
    };
};

/**
 * Funció auxiliar la qual, donat un objecte, revisa si algun dels seus items conté un true.
 * Si un dels valors de l'objecte és un altre objecte, aplica recursivitat i mira dins per cercar el mateix.
 * @param objecte {Object}
 * @returns true/false
 */
const revisarSiUnObjecteConteUnDelsSeusElementsATrue = (objecte) => {
    return Object.keys(objecte).reduce((hiHaError, clau) => {
        const valor = objecte[clau];
        if (typeof valor === 'object') {
            // Si l'item és un objecte apliquem recursivitat
            return revisarSiUnObjecteConteUnDelsSeusElementsATrue(valor) || hiHaError;
        } else {
            // Si no, el seu valor només pot contenir false o true
            return valor || hiHaError;
        }
    }, false);
};

/**
 * Comprova si el formulari conté errors i, si es així, retorna true
 * @param errors {Object}
 * @returns true/false
 */
const revisarSiExisteixenErrorsAlFormulari = (errors) => {
    if (!errors) return false;
    return revisarSiUnObjecteConteUnDelsSeusElementsATrue(errors);
};

/**
 * Retorna l'acció que actualitza l'estat de Redux per indicar que hi ha un enviament en curs
 * @returns {{type: AVIS_INTRODUCCIO_INSERIR_EN_CURS}}
 */
const peticioInserirAvisEnCurs = () => {
    return {
        type: AVIS_INTRODUCCIO_INSERIR_EN_CURS
    };
};

/**
 * Retorna l'acció que actualitza l'estat de Redux per indicar que l'enviament en curs s'ha finalitzat
 * @returns {{type: AVIS_INTRODUCCIO_INSERIR_FINALITZADA}}
 */
const peticioInserirAvisFinalitzada = () => {
    return {
        type: AVIS_INTRODUCCIO_INSERIR_FINALITZADA
    };
};

/**
 * Retorna true/false depenent de si és una foto o no
 * @returns {Boolean}
 */
const esUnaFoto = (item) => {
    const { type } = item;
    return typeof item === 'object' && item.size !== undefined && item.type !== undefined && type.includes('image');
};

/**
 * Construeix l'objecte amb les dades que s'han d'enviar per inserir l'avis
 * @param formulari {Object}
 * @returns avis {FormData}
 */
const generaAvisAPartirDelFormulari = (formulari) => {
    const { dades } = formulari;
    const { valors, idMeteorSeleccionat } = dades;

    const valorsSenseTipusFoto = Object.keys(valors).reduce((valorsSenseTipusFoto, clau) => {
        if (!esUnaFoto(valors[clau])) {
            valorsSenseTipusFoto[clau] = valors[clau];
        }
        return valorsSenseTipusFoto;
    }, {});

    // Important: assumim que només hi haurà una foto.
    const foto = Object.keys(valors).find((clau) => {
        return esUnaFoto(valors[clau]);
    });

    // Es construeix l'objecte de dades que s'enviarà
    const { data, coordenades, altitud, idVigilant } = dades;
    const nouDades = {
        data,
        coordenades,
        altitud,
        vigilant: idVigilant,
        valors: valorsSenseTipusFoto,
        idCampFoto: foto,
        idMeteor: idMeteorSeleccionat
    };

    // Contruïm el formData
    let formData = new FormData();
    formData.append('dades', JSON.stringify(nouDades));

    if (foto) {
        formData.append('foto', valors[foto]);
    }

    return formData;
};

/**
 * Petició d'inserció o edició d'un avís
 *
 * @param routerHistory
 * @returns {*}
 */
export const avisFormulariEnviar = (routerHistory) => {
    const notificacioCrearAvisError = 'Error inserint l\'avís';

    return (dispatch, getState) => {

        // Llencem l'acció d'AVIS_INTRODUCCIO_COMPROVAR .
        const estatPreValidacio = getState();
        const { meteors } = estatPreValidacio.avis;
        const { dades } = estatPreValidacio.avis.formulari;
        dispatch(checkAvisFormulariEnviar(dades, meteors));

        // Agafem l'estat resultant
        const estatPostValidacio = getState();
        const { formulari } = estatPostValidacio.avis;
        const idAvis = formulari.id;
        const { errors } = formulari;
        const conteError = revisarSiExisteixenErrorsAlFormulari(errors);

        // Si conté errors, tornem un missatge d'error
        if (conteError) {
            const notificacioCampsObligatorisNoInformatsAdvertencia = 'El formulari conté camps obligatoris no informats';
            crearNotificacioWarning(notificacioCampsObligatorisNoInformatsAdvertencia);
            return;
        }

        // Fem la construcció de l'objecte a enviar.
        const avis = generaAvisAPartirDelFormulari(formulari);

        // Llencem l'acció d'AVIS_INTRODUCCIO_INSERIR_EN_CURS.
        dispatch(peticioInserirAvisEnCurs());

        let promesa;

        if (idAvis) {
            const { urlFotoAEliminar } = formulari;
            avis.append('urlFotoAEliminar', urlFotoAEliminar);
            promesa = fetchEditarAvis(avis, idAvis); // editar avís
        } else {
            promesa = fetchAvisFormulariEnviar(avis); // crear avís
        }

        return promesa
            .then((response) => {
                // Llencem l'acció d'AVIS_INTRODUCCIO_INSERIR_FINALITZADA
                dispatch(peticioInserirAvisFinalitzada());

                // Fem el routerHistory per redireccionar a la pàgina d'avisos.
                routerHistory.push(rutaAvisos);

                const notificacioCrearAvisExit = 'Avís inserit correctament';
                // Avisem a l'usuari que l'avis s'ha inserit correctament.
                switch (response.status) {
                    case HTTPStatus.OK: {
                        crearNotificacioSuccess(notificacioCrearAvisExit);
                        break;
                    }
                    case HTTPStatus.PARTIAL_CONTENT: {
                        const notificacioCrearAvisAdvertencia = {
                            titol: notificacioCrearAvisExit,
                            descripcio: 'La foto no s\'ha pogut inserir.'
                        };
                        crearNotificacioWarning(notificacioCrearAvisAdvertencia.titol,
                            notificacioCrearAvisAdvertencia.descripcio);
                        break;
                    }
                    default: {
                        console.warn(`Error de tipus ${response.status}: ${response.body}`);
                        crearNotificacioError(notificacioCrearAvisError);
                    }
                }
            },
            errorServidor => {
                // Llencem l'acció d'AVIS_INTRODUCCIO_INSERIR_FINALITZADA
                dispatch(peticioInserirAvisFinalitzada());

                // Avisem a l'usuari que l'avis no s'ha inserit correctament.
                console.warn(errorServidor.body);
                dispatch(errorConsultaServidor(errorServidor, notificacioCrearAvisError));
            });

    };
};

/**
 * Recupera l'última data en la qual s'ha generat una imatge de radar.
 */
export const avisObtenirUltimaDataRadar = () => {
    return (dispatch) => {
        return fetchObtenirUltimaDataRadar()
            .then((resposta) => {
                dispatch(modificarUltimaDataRadar(resposta.dataUltimaTileGenerada));
            },(errorServidor) => {
                const notificacioObtenirUltimaDataRadarError = 'Error obtenint l\'última data del radar';
                dispatch(errorConsultaServidor(errorServidor, notificacioObtenirUltimaDataRadarError));
            });
    };
};

export const netejarUltimaDataRadar = () => {
    return modificarUltimaDataRadar(null);
};

const modificarUltimaDataRadar = (dataUltimaTileGeneradaRadar) => {
    return {
        type: AVIS_VISUALITZACIO_OBTENIR_ULTIMA_DATA_RADAR,
        dataUltimaTileGeneradaRadar
    };
};

export const avisVisualitzacioDeselccionarAvis = () => {};

const avisVisualitzacioObtenirComentaris = (comentaris) => {
    return {
        type: AVIS_VISUALITZACIO_OBTENIR_COMENTARIS,
        comentaris
    };
};

/**
 * Retorna l'acció per indicar que la petició d'obtenir comentaris es troba en curs
 * @returns {{type: AVIS_VISUALITZACIO_OBTENIR_COMENTARIS_EN_CURS}}
 */
const peticioObtenirComentarisEnCurs = () => ({ type: AVIS_VISUALITZACIO_OBTENIR_COMENTARIS_EN_CURS });

/**
 * Retorna l'acció per indicar que la petició d'obtenir comentaris ha finalitzat
 * @returns {{type: AVIS_VISUALITZACIO_OBTENIR_COMENTARIS_FINALITZADA}}
 */
const peticioObtenirComentarisFinalitzada = () => ({ type: AVIS_VISUALITZACIO_OBTENIR_COMENTARIS_FINALITZADA });

/**
 * Consulta els comentaris a servidor i llança les accions
 * corresponents depenent del resultat d'aquesta consulta
 *
 * @returns {*}
 */
export const obtenirComentaris = () => {

    return (dispatch) => {

        dispatch(peticioObtenirComentarisEnCurs());

        return fetchAvisComentaris()
            .then(comentaris => {
                dispatch(avisVisualitzacioObtenirComentaris(comentaris));
                dispatch(peticioObtenirComentarisFinalitzada());
            },(errorServidor) => {
                dispatch(peticioObtenirComentarisFinalitzada());
                const notificacioObtenirComentarisError = 'Error obtenint els comentaris';
                dispatch(errorConsultaServidor(errorServidor, notificacioObtenirComentarisError));
            });
    };

};

/**
 * Retorna l'acció per indicar que la petició d'eliminar un comentari amb idComentari es troba en curs
 * @param idComentari {Integer}
 * @returns {type: AVIS_VISUALITZACIO_ELIMINAR_COMENTARI_EN_CURS, id: {Integer}}
 */
const peticioEliminarComentariEnCurs = (idComentari) => {
    return {
        type: AVIS_VISUALITZACIO_ELIMINAR_COMENTARI_EN_CURS,
        id: idComentari
    };
};

/**
 * Retorna l'acció per indicar que la petició d'eliminar un comentari ha finalitzat
 * @param idComentari {Integer}
 * @returns {type: AVIS_VISUALITZACIO_ELIMINAR_COMENTARI_FINALITZADA}
 */
const peticioEliminarComentariFinalitzada = () => {
    return {
        type: AVIS_VISUALITZACIO_ELIMINAR_COMENTARI_FINALITZADA,
    };
};

/**
 * Retorna l'acció que elimina el comentari amb idComentari de l'estat
 * @param idComentari {Integer}
 * @returns {type: AVIS_VISUALITZACIO_ELIMINAR_COMENTARI, id: {Integer}}
 */
const avisVisualitzacioEliminarComentari = (idComentari) => {
    return {
        type: AVIS_VISUALITZACIO_ELIMINAR_COMENTARI,
        id: idComentari
    };
};

/**
 * Llança la petició per eliminar un comentari
 *
 * @returns {*}
 */
export const eliminarComentari = (idComentari) => {
    return (dispatch) => {

        dispatch(peticioEliminarComentariEnCurs(idComentari));

        return fetchAvisEliminarComentari(idComentari)
            .then(() => {
                dispatch(avisVisualitzacioEliminarComentari(idComentari));
                dispatch(peticioEliminarComentariFinalitzada());
            },(errorServidor) => {
                dispatch(peticioEliminarComentariFinalitzada());
                const notificacioEliminarComentariError = 'Error eliminant el comentari';
                dispatch(errorConsultaServidor(errorServidor, notificacioEliminarComentariError));
            });
    };

};

/**
 * Omple el formulari d'introducció d'avís amb les dades d'un avís existent
 *
 * @param avis {Object}
 * @returns {*}
 */
export const omplirFormulariAmbUnAvis = (avis) => {

    return {
        type: AVIS_OMPLIR_FORMULARI_AMB_UN_AVIS,
        avis
    };

};

/**
 * Omple la url de la foto que s'ha d'eliminar per a fer la petició al servidor
 *
 * @param avis {Object}
 * @returns {*}
 */
export const avisIntroduccioModificarUrlFotoAEliminar = (urlFotoAEliminar) => {
    return {
        type: AVIS_INTRODUCCIO_MODIFICAR_URL_FOTO_A_ELIMINAR,
        urlFotoAEliminar
    };
};



// WEBPACK FOOTER //
// ./src/actions/avis.js